import type { TStyleSheet } from '~/types/emotion-styles';

const styles: TStyleSheet = {
  sectionWrapper: {
    marginTop: 40,
  },
};

export default styles;
